import { createRoutine, UnifiedRoutine } from 'redux-saga-routines';
import { Action } from 'redux';
import { VehicleMonitoringAction } from '@modules/vehicle-monitoring/types/actions';

export const vehicleMonitoringIndexRoutine = createRoutine(VehicleMonitoringAction.INDEX);

export const vehicleMonitoringNotifyRoutine: UnifiedRoutine<(payload?: any) => Action>[] = [vehicleMonitoringIndexRoutine];
